import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const configSelector = createSelector(rootSelector, s => s.config);

export const clientBasePathSelector = createSelector(configSelector, config => config.clientBasePath);
export const baseUrlSelector = createSelector(configSelector, config => config.baseURL);
export const externalServicesSelector = createSelector(configSelector, config => config.externalServices);
